module.exports = __webpack_public_path__ + "static/iga1-661135775470f7fc7e175f92d311bf7a.png";